/* t13 announcement compatibility runtime. No diagnostics are emitted here. */
(() => {
  'use strict';
  if (window.DawnBaseAnnouncement?.copyCode) return;
  window.DawnBaseAnnouncement = window.DawnBaseAnnouncement || {};
  window.DawnBaseAnnouncement.copyCode = function copyCode(event) {
    const button = event.currentTarget;
    const code = (button?.dataset?.code || '').trim();
    navigator.clipboard.writeText(code);
    button.classList.add('success');
    setTimeout(() => button.classList.remove('success'), 2000);
  };
})();